<template>
  <div>
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :columns="columns"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :import-config="importConfig"
        :export-config="exportConfig"
        ref="grid"
        :cell-click="chooseRow"
        @toolbar-addData="addRow"
        @toolbar-delData="delRow"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
        <vxe-button v-auth="'DESIGN'" @click="designOnline">在线设计</vxe-button>
        <btn-confirm style='margin-left:15px'
            title="确定要部署吗?"
            @confirm="setRow"
        >
          <vxe-button v-auth="'ARRANGE'">部署</vxe-button>
        </btn-confirm>
      </template>
    </x-grid>


    <!-- 详情页 -->
    <a-modal
        title="模型管理"
        centered
        :footer="null"
        :maskClosable="false"
        :closable="true"
        @cancel="closeEdit"
        :visible="editModalVisible"
        :width="600"
    >
      <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
      <formDetail :rowId="editRowId"
                  v-if="editModalVisible"
                  ref="detailForm"
                  @cancelled="closeEdit()"
                  @saved="closeEdit(true)">
      </formDetail>
    </a-modal>

  </div>
</template>

<script>
import XGrid from '@/components/grid/XGrid';
import {GridMixin} from "@/utils/GridMixin";
import {
  formatter as fmt
} from "@/utils/ebase-formatter"
import api from '@/services/api'
import {loadBaseCodeData} from "@/services/baseCodeSource";
import {dataApi} from "@/services/workflow/modelManage";

import formDetail from "@/pages/web/workflow/modelManage/modelManageDetail";

console.info(fmt, loadBaseCodeData);//防止未用到报未定义错误 用到了可删除

const fac = XGrid.factory;


//列表接口
const url = api.workflow.MODEL;

//主键
const rowId = 'id';

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumn("id", "ID", 100),
  fac.makeColumn("name", "模型名称", 160),
  fac.makeColumn("key", "模型标志", 160),
  fac.makeColumn("revision", "版本", 100),
  fac.makeColumn("createTime", "创建时间", 160),
  fac.makeColumn("lastUpdateTime", "更新时间", 160),
  fac.makeColumn("metaInfo", "模型标志", 300),
]

let formConfig = fac.makeFormConfig(columns, [
  {field: 'name'},
  {field: 'key'},
])


//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  import: false,
  export: false,
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);


export default {
  mixins: [GridMixin],
  components: {
    formDetail
  },
  // authorize: {
  //   addRow: "ADD",
  //   updateRow: 'UPDATE',
  //   delRow: 'DELETE',
  // },
  data() {
    return {
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
    }
  },
  methods: {
    cellDbClick({row}) {
      console.log(row)
    },
   /* async delRow() {
      let rows = this.getRows();
      if (rows.length !== 1) {
        return this.$message.error('请选择一条数据');
      }
      await dataApi.deleteRow(rows[0][this.rowId]).then(() => {
        this.$refs['grid'].$refs['xGrid'].removeCheckboxRow();
      }).catch(e => {
        this.$message.error(e)
      })
    },*/
    designOnline() {
      let rows = this.getRows();
      if (rows.length !== 1) {
        return this.$message.error('请选择一条数据');
      }

      //改成可视化地址
      // window.open(" http://192.168.41.239:5500/public/modeler.html?modelId=" + rows[0][this.rowId] + "&token=" + this.user.token, "_blank");
      window.open(process.env.VUE_APP_WORKFLOW_URL + "/public/modeler.html?modelId=" + rows[0][this.rowId] + "&token=" + this.user.token, "_blank");
      // window.open(" http://crm.cnhtc:8082/public/modeler.html?modelId=" + rows[0][this.rowId] + "&token=" + this.user.token, "_blank");

    },
    async setRow() {
      let rows = this.getRows();
      if (rows.length !== 1) {
        return this.$message.error('请选择一条数据');
      }
      await dataApi.modelSet(rows[0][this.rowId]).then(() => {
        this.$message.success('部署成功');
        this.refresh();
        // this.$refs['grid'].$refs['xGrid'].removeCheckboxRow();
      })
    }
  }
}
</script>

<style scoped>
</style>